import { c as _c } from "react/compiler-runtime";
import { useFeatureFlag, useIsMobile } from '@newfront-insurance/admin-ui';
import { cn } from '@newfront-insurance/core-ui/v2';
import { useMemo } from 'react';
import { ChatContainer } from '../components/chat-container';
import { ChatContent } from '../components/chat-content';
import { AccountSelector, ChatHeader, NewChatButton, ToggleSidebar } from '../components/chat-header';
import { ChatHeaderActions } from '../components/chat-header/chat-header-actions';
import { ChatRoot } from '../components/chat-root';
import { ChatSidebar, ChatSidebarFilterTabs, ChatSidebarHistory, ChatSidebarNewChat, ChatSidebarSearch, ChatSidebarSettingsButton } from '../components/chat-sidebar';
import { useChatOverlayContext } from '../contexts/chat-overlay-context';
import { createDefaultDataPartRenderers, createDefaultToolRenderers } from '../lib/default-renderers';
import { NovaChatProvider } from '../providers';

/**
 * Container component that renders the chat UI.
 * Reads all props from context - no prop drilling needed.
 * All child components are self-contained and manage their own state.
 */
export function NovaChatContainer() {
  const $ = _c(28);
  const {
    isVisible,
    authProvider,
    userUuid,
    accountUuid,
    userScopes: scopes,
    initialMessages,
    isLoadingMessages: loading,
    placeholder,
    isStandaloneMode,
    isSidebarOpen,
    isFullscreen
  } = useChatOverlayContext();
  const isNovaSourcesRenderingEnabled = useFeatureFlag("nova-sources-rendering", false);
  const {
    isMobile
  } = useIsMobile();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = createDefaultToolRenderers();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  t0 = t1;
  const toolRenderers = t0;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = createDefaultDataPartRenderers();
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  t2 = t3;
  const dataPartRenderers = t2;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChatSidebar><ChatSidebarNewChat /><ChatSidebarSettingsButton /><ChatSidebarSearch /><ChatSidebarFilterTabs /><ChatSidebarHistory /></ChatSidebar>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = (isStandaloneMode || isFullscreen) && isSidebarOpen && !isMobile;
  const t6 = (isStandaloneMode || isFullscreen) && !isSidebarOpen && !isMobile;
  let t7;
  if ($[3] !== t5 || $[4] !== t6) {
    t7 = cn("flex size-full flex-col", {
      "ml-[253px]": t5,
      "ml-[63px]": t6
    });
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== isMobile) {
    t8 = <ChatHeader>{isMobile ? <><ToggleSidebar /><div className="flex flex-1 justify-center"><AccountSelector /></div><NewChatButton /></> : <><AccountSelector /><ChatHeaderActions /></>}</ChatHeader>;
    $[6] = isMobile;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== isNovaSourcesRenderingEnabled || $[9] !== loading || $[10] !== placeholder) {
    t9 = <ChatContent isLoading={loading} toolRenderers={toolRenderers} dataPartRenderers={dataPartRenderers} placeholder={placeholder} enableSourcesRendering={isNovaSourcesRenderingEnabled} />;
    $[8] = isNovaSourcesRenderingEnabled;
    $[9] = loading;
    $[10] = placeholder;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <ChatRoot>{t8}{t9}</ChatRoot>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t7) {
    t11 = <div className={t7}>{t10}</div>;
    $[15] = t10;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== accountUuid || $[19] !== authProvider || $[20] !== initialMessages || $[21] !== scopes || $[22] !== t11 || $[23] !== userUuid) {
    t12 = <NovaChatProvider authProvider={authProvider} userUuid={userUuid} accountUuid={accountUuid} scopes={scopes} initialMessages={initialMessages}>{t4}{t11}</NovaChatProvider>;
    $[18] = accountUuid;
    $[19] = authProvider;
    $[20] = initialMessages;
    $[21] = scopes;
    $[22] = t11;
    $[23] = userUuid;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== isVisible || $[26] !== t12) {
    t13 = <ChatContainer isVisible={isVisible}>{t12}</ChatContainer>;
    $[25] = isVisible;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}